import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  DateRangPickerField,
} from "../../../_metronic/_partials/controls";
import { Col, Row, Button, Accordion } from "react-bootstrap";
import moment from "moment";

import * as actions from "./_redux/Actions";
import {
  dateFormatCol,
  dateTimeFormatCol,
} from "../../components/column-formatters";
import * as UIHelpers from "../../components/UIHelpers";
import "./ContestList.css";

import sorter from "sort-nested-json";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import * as columnFormatters from "../../components/column-formatters";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { imageUrl } from "../../components/UIHelpers";
export default function AllocatedUserList() {
  const dispatch = useDispatch();

  const columns = [
    {
      text: "",
      sort: false,
    },
    {
      dataField: "noIndex",
      text: "#",
      sort: true,
      show: true,
      format: {
        style: {
          width: '40px',
          minWidth: '40px',
        },
      },
    },
    {
      dataField: "playerName",
      text: "InGame Name",
      sort: true,
      show: true,
    },
    {
      dataField: "captain_sass_id",
      text: "User Name",
      sort: true,
      show: true,
    },
    // {
    //   dataField: "team",
    //   text: "Team",
    //   sort: true,
    //   show: true,
    // },
    {
      dataField: "userData.countriesData.name",
      text: "Country",
      sort: true,
      show: true,
    },
    {
      dataField: "userData.phone",
      text: "Mobile",
      sort: true,
      show: true,
    },
    // {
    //   dataField: "userCurrentCurrencyWallet.inCurrencyWallet",
    //   text: "In Currency Balance",
    //   sort: true,
    //   show: true,
    // },
    // {
    //   dataField: "userCurrentCurrencyWallet.outCurrencyWallet",
    //   text: "Out Currency Balance",
    //   sort: true,
    //   show: true,
    // },
    {
      dataField: "rank",
      text: "Rank",
      sort: true,
      show: true,
    },
    {
      dataField: "kill",
      text: "Kill",
      sort: true,
      show: true,
    },
    {
      dataField: "createdAt",
      text: "Joined Date",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.dateFormatCol,
      }
    },
    {
      dataField: "createdAt",
      text: "Joined Time",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.timeFormatCol,
      }
    },
    {
      dataField: "createdAt",
      text: "Allocated Date",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.dateFormatCol,
      }
    },
    {
      dataField: "createdAt",
      text: "Allocated Time",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.timeFormatCol,
      }
    },
    {
      dataField: "isWildCard",
      text: "Wild Card Entry",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.YesNoColumnFormatter,
      }
    }
  ];

  const [rows, setRows] = useState([]);
  const [allColumns, setAllColumns] = useState(columns);
  const [cols, setCols] = useState(columns);
  const [sortDirection, setSortDirection] = useState([]);
  const [showSortArrow, setShowSortArrow] = useState([]);
  const [searchApply, setSearchApply] = useState(false);
  const [finalResult, setFinalResult] = useState([]);
  const [extra, setextra] = useState([]);
  const [isExtra, setIsExtra] = useState(false);
  const [isValidatedWinning, setIsValidatedWinning] = useState(false);
  const [isUserContestWinningSubmit, setIsUserContestWinningSubmit] = useState(false);
  const [selectedId, setSelectedId] = useState();

  const previousPage = () => {
    setIsExtra(false)
  }

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );

  const {
    actionsLoading,
    listLoading,
    allocatedUserList,
    contestData
  } = currentState;
  console.log(contestData);
  useEffect(() => {
    var id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];
    dispatch(actions.fetchContestViewDetails(id));
    dispatch(actions.fetchAllocatedUsersList(id));
  }, []);

  useEffect(() => {
    console.log("allocatedUserList", allocatedUserList)
  }, [allocatedUserList]);

  const CurrencyIcoon = ({ item }) => {
    return (
      <span className="text-dark-50 font-weight-bold">
        {item.currency && item.currency.img ? (
          <img
            className="currency"
            // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currency &&
            //   item.currency.img.default}`}
              src={imageUrl(item.currency &&
                item.currency.img.default)}
            alt="currency"
          />
        ) : (
          <span className="text-dark-50 font-weight-bold">₹</span>
        )}
      </span>
    );
  };

  const onClickSortCol = (key) => {
    let show_sort_arrow = showSortArrow;

    Object.keys(show_sort_arrow).forEach(obj_key => {
      if (obj_key === key)
        show_sort_arrow[obj_key] = true;
      else
        show_sort_arrow[obj_key] = false;
    })
    setShowSortArrow(show_sort_arrow);

    // let sort_key = dataFromNestedKeys(key)

    let arrayCopy = [...rows];
    // arrayCopy.sort(compareBy(key, sortDirection[key]));

    if (sortDirection[key] === "asc")
      arrayCopy = sorter.sort(arrayCopy).asc(key);
    else
      arrayCopy = sorter.sort(arrayCopy).desc(key);

    setRows(arrayCopy);
    // this.setState({rows: arrayCopy});

    let sort_direction = sortDirection;
    if (sort_direction[key] === 'asc')
      sort_direction[key] = 'desc';
    else if (sort_direction[key] === 'desc')
      sort_direction[key] = 'asc';
    setSortDirection(sort_direction);
  };

  const createTableCol = () => {
    return (
      allColumns.map((value, i) => {
        if (value?.format?.type !== 'rowCollasible') {
          let style_icon = { color: '#fff' };
          let arrow_direction = 'down';
          let className_cell_value = ''

          if (value?.sort && showSortArrow[value?.dataField])
            style_icon.display = 'inline';
          else
            style_icon.display = 'none';

          if (sortDirection[value?.dataField] === 'asc')
            arrow_direction = 'down';
          else if (sortDirection[value?.dataField] === 'desc')
            arrow_direction = 'up';

          if (value?.dataField === 'image')
            className_cell_value = 'data_table_cell_value_image';
          else
            className_cell_value = 'data_table_cell_value';

          return (
            <th data-field={value?.dataField} data-sort="desc" key={i}
              className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
              onClick={() => { value?.sort === true && onClickSortCol(value?.dataField) }}
              colSpan={1} rowSpan={1} style={value?.format?.thStyle}
            >
              <span className={`${className_cell_value} data_table_th_value`} style={value?.format?.style}>
                {value?.text}
                <i className={`flaticon2-arrow-${arrow_direction} icon-nm ml-1`} style={style_icon}>
                </i>
              </span>
            </th>
          )
        }
      })
    )
  };

  useEffect(() => {
    if (allocatedUserList && allocatedUserList?.data?.length > 0) {
      let temp_user_result = allocatedUserList.data.map((item, i) => (item.isExtraPlayer === false || item.isExtraPlayer === undefined ? {
        "_id": item._id,
        "kills": 0,
        "rank": 0,
        "isHacking": false,
        "isProof": false
      } : {
        "inGameUserName": item.playerInGameName,
        "kills": 0,
        "rank": 0,
        "isHacking": false,
        "isProof": false
      }));
      console.log(temp_user_result, '*-*-*-*-*-*-*-*-*-*');
      setFinalResult(temp_user_result);
      setRows(allocatedUserList?.data);

    }
  }, [allocatedUserList]);

  const saveContestList = (value, name, index) => {
    let temp = [...finalResult];
    if (name === "kills") {
      if (value == "") {
        value = 0
      }
      if (parseInt(temp[index].rank) != 0) {
        temp[index].kills = parseInt(value);
      }
      else {
        temp[index].kills = 0;
        NotificationManager.error('Please enter rank first.!!', 'Error');
      }
    }
    else if (name === "rank") {
      console.log(value);
      if (value == "") {
        value = 0
      }
      temp[index].rank = parseInt(value);

      if (parseInt(value) <= 0) {
        temp[index].kills = 0;
      }
    }
    else if (name === "isHacking") {
      temp[index].isHacking = value;
    }
    else if (name === "isProof") {
      temp[index].isProof = value;
    }
    // else if (name === "isExtraPlayer") {
    //   temp[index].isExtraPlayer = value;
    // }
    else if (name === "inGameUserName") {
      temp[index].inGameUserName = value;
    }
    setFinalResult(temp)
  }
  function toFindDuplicates(values) {
    var valueArr = values.map(function (item) { return item.rank });

    for (var i = 0; i < valueArr.length; i++) {
      if (valueArr[i] == 0) {
        valueArr.splice(i, 1);  //data[i] is replaced with data
        i--; //reduce the i counter;
      }
    }

    var isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) != idx
    });

    return isDuplicate;
  }
  const nextP = () => {
    if (finalResult.filter((e) => e.rank > 0).length > 0) {
      if (contestData.data?.numberOfPlayedUsers > 0) {
        if (finalResult.filter((e) => e.rank > contestData.data?.numberOfPlayedUsers).length > 0) {
          NotificationManager.error('Rank number should not be more than total played user!!', 'Error');
        } else {
          if (!toFindDuplicates(finalResult)) {
            let totalRanksArr = [];
            let regUserRankArr = [];
            let absentRank = [];
            // console.log("finalResult==>",finalResult);
            finalResult.forEach((item) => {
              regUserRankArr.push(item.rank);
            });
            for (let i = 0; i < contestData.data?.numberOfPlayedUsers; i++) {
              totalRanksArr.push(i + 1)
            }
            absentRank = totalRanksArr.filter(e => !regUserRankArr.includes(e));

            // console.log("totalRanksArr==>",totalRanksArr);
            // console.log("regUserRankArr==>",regUserRankArr);
            console.log("absentRank==>", absentRank);
            //const loopTime = contestData.data?.numberOfPlayedUsers - contestUsers?.data?.length;
            let array = []
            for (let i = 0; i < absentRank.length; i++) {
              let obj = { inGameUserName: "", kills: 0, killsAmount: 0, rankAmount: 0, rank: absentRank[i], isHacking: false, isProof: false, }
              // console.log(`Iteration is #${i}`);
              array.push(obj)
            }
            // console.log("array",array);
            setextra(array);
            setIsExtra(true)
          }
          else {
            NotificationManager.error('You can not add duplicate ranks.!!', 'Error');
          }
        }
      } else {
        NotificationManager.error('Please add number of played users first.!!', 'Error');
      }
    } else {
      NotificationManager.error('Please add atleast one rank.!!', 'Error');
    }
  }
  const validateWinning = () => {
    let errMsg = '';

    extra.forEach((euser, index) => {
      if (!euser.inGameUserName) {
        errMsg += `Please enter user name for user ${index + 1}`;
        NotificationManager.error(`Please enter user name for user ${index + 1}`, 'Error');
        return;
      }
    })

    extra.forEach((euser, index) => {
      if (!euser.rank) {
        errMsg += `Please enter rank for user ${index + 1}`;
        NotificationManager.error(`Please enter rank for user ${index + 1}`, 'Error');
        return;
      }
    })

    if (errMsg) {
      //NotificationManager.error(errMsg, 'Error');
      return;
    } else {
      var arr3 = [...finalResult, ...extra];
      if (!toFindDuplicates(arr3)) {
        let totalKill = 0, totalRank = [];
        arr3.forEach(a => {
          totalKill = parseInt(totalKill) + parseInt(a.kills);
        });
        arr3.forEach(a => {
          totalRank.push(a.rank);
        });
        if (totalKill > (contestData.data?.numberOfPlayedUsers - 1)) {
          NotificationManager.error('Total kill should not be more than total played user!!', 'Error');
        }
        else {
          var missing = new Array();

          for (var i = 1; i <= contestData.data?.numberOfPlayedUsers; i++) {
            if (totalRank.indexOf(i) == -1) {
              missing.push(i);
              NotificationManager.error(`Missing rank number ${i}!!`, 'Error');
            }
          }

          if (missing.length == 0) {
            setIsValidatedWinning(true);
          }
          //setIsValidatedWinning(true);
          //alert(true);
        }
      }
      else {
        NotificationManager.error("You can not add duplicate ranks!!", 'Error');
      }
    }
  }
  const reloadLocation = () => {
    window.location.reload();
  };

  const saveContestResult = () => {
    // console.log(extra)
    // console.log(finalResult);
    let contestPlayer = finalResult;
    if (extra.length > 0) {
      contestPlayer.concat(extra)
    }
    let body = {
      "contestPlayer": contestPlayer,
      "roundId": contestData.data?.roundId,
      "contestId": contestData.data?._id,
      "tournamentId": contestData.data?.tournamentId
    }
    dispatch(actions.saveContestResult(body)).then((sucess) => sucess ? reloadLocation() : null);;
  }

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <Card className="card_border">
            <NotificationContainer />
            <div className="card-header p-0">
              <div className="my-5 row mx-0 px-4 w-100 d-flex justify-content-between">
                <div className="" style={{ fontSize: '24px', fontWeight: '600' }}>Allocated Team List</div>
              </div>
            </div>

            <CardBody className="p-0 w-100">

              <table className="table dataTable datatable-table contest_data_table_table w-100">
                <thead className="datatable-head data_table_head w-100">
                  <tr className="datatable-row" style={{ left: '0px', }}>
                    {createTableCol()}
                  </tr>
                </thead>
                {!isExtra ?
                  <tbody className="datatable-body data_table_body w-100">
                    {rows.length > 0 ?
                      rows.map((value, i) => {
                        var backgroundColor = 'white';
                        if (value?.isRejected)
                          backgroundColor = `#F64E60`;

                        return (
                          <>
                            <tr data-row={value?._id} className="datatable-row data_table_tr" style={{ left: '0px', backgroundColor: backgroundColor }} key={i}>
                              <td className="datatable-cell data_table_cell" onClick={() => { selectedId === value._id ? setSelectedId('') : setSelectedId(value._id) }}>
                                {selectedId !== value._id ? <i class="fa fa-solid fa-plus fa-sm text-dark" aria-hidden="true"></i>
                                  : <i class="fa fa-solid fa-minus fa-sm text-dark" aria-hidden="true"></i>
                                }
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{i + 1}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.playerName}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.captain_sass_id}</span>
                              </td>
                              {/* <td className="datatable-cell data_table_cell">
                                {value?.teamDetails && value?.teamDetails.length > 0 ?
                                  <>
                                    <tr>
                                      <th>In Game Name</th>
                                      <th>User Name</th>
                                    </tr>
                                    {value.teamDetails.map((teamValue) =>
                                      <tr key={teamValue._id}>
                                        <td>
                                          {teamValue?.playerInGameName}
                                        </td>
                                        <td>{teamValue?.user_saas_id}</td>
                                      </tr>
                                    )}
                                  </>
                                  :
                                  <></>
                                }
                              </td> */}
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.userData?.countriesData?.name}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{value?.userData?.phone}</span>
                              </td>
                              {/* <td className="datatable-cell data_table_cell">
                                  <span className="data_table_cell_value">{value?.userCurrentCurrencyWallet?.inCurrencyWallet ? `${value.userCurrentCurrencyWallet.inCurrencyWallet.winningAmount} ( ${value.userCurrentCurrencyWallet.inCurrencyWallet.userInCurrencyName} )` : <></>}</span>
                                </td>
                                <td className="datatable-cell data_table_cell">
                                  <span className="data_table_cell_value">{value?.userCurrentCurrencyWallet?.outCurrencyWallet ? `${value.userCurrentCurrencyWallet.outCurrencyWallet.winningAmount} ( ${value.userCurrentCurrencyWallet.outCurrencyWallet.userInCurrencyName} )` : <></>}</span>
                                </td> */}
                              <td className="datatable-cell data_table_cell">
                                {
                                  contestData.data?.status === 'review' && contestData?.data?.ssUpload.length > 0 ?
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Rank"
                                      value={finalResult[i].rank}
                                      name="rank"
                                      onChange={(e) => {
                                        saveContestList(e.target.value, "rank", i);
                                      }}
                                    />
                                    :
                                    <span className="data_table_cell_value">{value?.rank || 0}</span>
                                }
                              </td>
                              <td className="datatable-cell data_table_cell">
                                {
                                  contestData.data?.status === 'review' && contestData?.data?.ssUpload.length > 0 ?
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Kill"
                                      value={finalResult[i].kills}
                                      name="kill"
                                      onChange={(e) => {
                                        saveContestList(e.target.value, "kills", i);
                                      }}
                                    />
                                    :
                                    <span className="data_table_cell_value">{value?.kills || 0}</span>
                                }
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{columnFormatters.dateFormatCol(value?.createdAt)}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{columnFormatters.timeFormatCol(value?.createdAt)}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{columnFormatters.dateFormatCol(value?.allocationCreatedAt)}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{columnFormatters.timeFormatCol(value?.allocationCreatedAt)}</span>
                              </td>
                              <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">{columnFormatters.YesNoColumnFormatter(value?.isWildCard)}</span>
                              </td>
                            </tr>
                            {
                              selectedId === value._id &&
                              <tr>
                                <td colspan="12">
                                  <span class="data_table_cell_value">
                                    <div class="d-flex flex-column flex-grow-1 pr-8 bg-secondary">
                                      <div class="d-flex flex-wrap">
                                        <table class="w-100">
                                          <tr>
                                            <th>User Id</th>
                                            <th></th>
                                            <th>Player Name</th>
                                            <th></th>
                                            <th>Player In Game Name</th>
                                            <th></th>
                                            <th>Character Id</th>
                                            <th></th>
                                            <th>Discord Id</th>
                                          </tr>
                                          {
                                            value.teamDetails.length > 0 &&
                                            value.teamDetails.map((teamValue) => {
                                              return console.log(teamValue) || <tr>
                                                <td>{teamValue.user_saas_id}</td>
                                                <td></td>
                                                <td>{teamValue.playerName}</td>
                                                <td></td>
                                                <td>{teamValue.playerInGameName}</td>
                                                <td></td>
                                                <td>{teamValue.charId}</td>
                                                <td></td>
                                                <td>{teamValue.discordId}</td>
                                              </tr>
                                            })}
                                        </table>
                                      </div>
                                    </div>
                                  </span>
                                </td>
                              </tr>
                            }
                          </>
                        )
                      })
                      :
                      <tr className="datatable-row data_table_tr" style={{ left: '0px' }}>
                        <td colSpan={11} className="datatable-cell data_table_cell text-center font-weight-bold">
                          No Data Found
                        </td>
                      </tr>
                    }
                  </tbody>
                  : <tbody className="datatable-body data_table_body w-100">
                    {extra.length > 0 ?
                      extra.map((value, i) => {
                        var backgroundColor = 'white';
                        if (value?.isRejected)
                          backgroundColor = `#F64E60`;

                        return (
                          <tr data-row={value?._id} className="datatable-row data_table_tr" style={{ left: '0px', backgroundColor: backgroundColor }} key={i}>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">{i + 1}</span>
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="User Name"
                                value={value.inGameUserName}
                                style={{ width: '150px' }}
                                onChange={(e) => {
                                  let temp = [...extra];
                                  temp[i].inGameUserName = e.target.value;
                                  setextra(temp);
                                }}
                              />
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                              {/* {value?.teamDetails && value?.teamDetails.length > 0 ?
                                    <>
                                        <tr>
                                            <th>In Game Name</th>
                                            <th>User Name</th>
                                        </tr>
                                        {value.teamDetails.map((teamValue) =>
                                            <tr key={teamValue._id}>
                                                <td>
                                                  {teamValue?.playerInGameName}
                                                </td>
                                                <td>{teamValue?.user_saas_id}</td>
                                            </tr>
                                        )}
                                    </>
                                    :
                                    <></>
                                  } */}
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                              {/* <span className="data_table_cell_value">{value?.userData?.countriesData?.name}</span> */}
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                              {/* <span className="data_table_cell_value">{value?.userData?.phone}</span> */}
                            </td>
                            {/* <td className="datatable-cell data_table_cell">
                                  <span className="data_table_cell_value">N/A</span>
                                </td>
                                <td className="datatable-cell data_table_cell">
                                  <span className="data_table_cell_value">N/A</span>
                                </td> */}
                            <td className="datatable-cell data_table_cell">
                              {
                                contestData.data?.status === 'review' && contestData?.data?.ssUpload.length > 0 ?
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Rank"
                                    value={value.rank}
                                    name="rank"
                                    disabled={true}
                                  // onChange={(e) => {
                                  //   saveContestList(e.target.value, "rank", i);
                                  // }}
                                  />
                                  :
                                  <span className="data_table_cell_value">{value?.rank || 0}</span>
                              }
                            </td>
                            <td className="datatable-cell data_table_cell">
                              {
                                contestData.data?.status === 'review' && contestData?.data?.ssUpload.length > 0 ?
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Kill"
                                    value={value.kills}
                                    name="kill"
                                  // onChange={(e) => {
                                  //   saveContestList(e.target.value, "kills", i);
                                  // }}
                                  />
                                  :
                                  <span className="data_table_cell_value">{value?.kills || 0}</span>
                              }
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                              {/* <span className="data_table_cell_value">{columnFormatters.dateFormatCol(value?.createdAt)}</span> */}
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                              {/* <span className="data_table_cell_value">{columnFormatters.timeFormatCol(value?.createdAt)}</span> */}
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                              {/* <span className="data_table_cell_value">{columnFormatters.dateFormatCol(value?.allocationCreatedAt)}</span> */}
                            </td>
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">N/A</span>
                              {/* <span className="data_table_cell_value">{columnFormatters.timeFormatCol(value?.allocationCreatedAt)}</span> */}
                            </td>
                          </tr>
                        )
                      })
                      :
                      <tr className="datatable-row data_table_tr" style={{ left: '0px' }}>
                        <td colSpan={11} className="datatable-cell data_table_cell text-center font-weight-bold">
                          No Data Found
                        </td>
                      </tr>
                    }
                  </tbody>
                }
              </table>


              <div className="card-footer p-0">
                {
                  contestData.data?.status === 'review' ?
                    contestData.data?.numberOfPlayedUsers > rows.length ?
                      <div className="btn-group btn-group-lg float-right m-5">
                        {isExtra !== false && isExtra !== "false" && isValidatedWinning !== true && isValidatedWinning !== "true" ?
                          <button type="submit" className="btn btn-dark float-left" onClick={() => { previousPage() }}>Previous</button>
                          :
                          <button type="submit" className="btn btn-dark float-left" disabled>Previous</button>
                        }

                        {isExtra !== false && isExtra !== "false" ?
                          isValidatedWinning !== true && isValidatedWinning !== "true" ?
                            <button type="submit" className="btn btn-dark float-left" onClick={() => { validateWinning() }}>Validate Winning</button>
                            :
                            <button type="submit" className="btn btn-dark float-left" disabled>Validate Winning </button>
                          :
                          <button type="submit" className="btn btn-dark float-left" onClick={() => { nextP() }} >Next</button>
                        }

                        {isValidatedWinning !== false && isValidatedWinning !== "false" ?
                          isUserContestWinningSubmit !== true && isUserContestWinningSubmit !== "true" ?
                            <button type="submit" className="btn btn-dark float-left" onClick={() => { saveContestResult() }}>
                              Submit
                            </button>
                            :
                            <button className="btn btn-dark float-left" type="button" disabled>
                              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                              Submit
                            </button>
                          :
                          <button type="submit" className="btn btn-dark float-left" disabled>
                            Submit
                          </button>
                        }
                      </div>
                      : <div className="btn-group btn-group-lg float-right m-5">
                        {
                          isValidatedWinning !== true && isValidatedWinning !== "true" ?
                            <button type="submit" className="btn btn-dark float-left" onClick={() => { validateWinning() }}>Validate Winning</button>
                            :
                            <button type="submit" className="btn btn-dark float-left" disabled>Validate Winning </button>
                        }
                        {isValidatedWinning !== false && isValidatedWinning !== "false" ?
                          isUserContestWinningSubmit !== true && isUserContestWinningSubmit !== "true" ?
                            <button type="submit" className="btn btn-dark float-left" onClick={() => { saveContestResult() }}>
                              Submit
                            </button>
                            :
                            <button className="btn btn-dark float-left" type="button" disabled>
                              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                              Submit
                            </button>
                          :
                          <button type="submit" className="btn btn-dark float-left" disabled>
                            Submit
                          </button>
                        }
                      </div>
                    : <></>
                }
              </div>

              {/* <DataTable
                  rows={rows ? rows : []}
                  columns={columns}
                /> */}
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  )
}